import { connect } from 'react-redux'
import get from 'lodash/get'

import {
  playRoute as onPlayRoute,
  pauseRoute as onPauseRoute,
  setCurrentPoint as onSetCurrentPoint,
  clearPlayerData as onClearPlayerData
} from '../../actions/intelligenceTimeRangePlayerActions'

const mapStateToProps = (state) => ({
  isPlay: get(state, ['intelligenceTimeRangePlayer', 'isPlay'], false),
  currentPointIndex: get(state, ['intelligenceTimeRangePlayer', 'currentPointIndex'], 0),
  currentPointDate: get(state, ['intelligenceTimeRangePlayer', 'currentPointDate'], 0)
})

const mapDispatchToProps = {
  onPlayRoute,
  onPauseRoute,
  onSetCurrentPoint,
  onClearPlayerData
}

const withIntelligenceTimeRangePlayer = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withIntelligenceTimeRangePlayer }